import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { CopyDirective } from '../../../directives/copy.directive';
import { ICONS, StateEnum } from '@aksia/infrastructure';

@Component({
  selector: 'label',
  imports: [IconComponent, CopyDirective],
  templateUrl: './label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  //#region Host Bindings

  @HostBinding('attr.uilabel')
  get UiLabelAttr() {
    return '';
  }

  //#endregion

  //#region Inputs/Outputs

  label = input<string>();
  labelTip = input<string>();
  labelCssClass = input<string>();
  title = input<string>();
  state = input<StateEnum>();

  //#endregion

  //#region Properties

  protected readonly ICONS = ICONS;

  //#endregion
}
